import { Component, input, OnInit } from '@angular/core';
import { AssessmentInfoComponent } from '../assessment-info/assessment-info.component';
import { AssessmentRowComponent } from '../../assessments-tab/assessment-row/assessment-row.component';
import { EmrListComponent } from "../../../../shared/emr-list/emr-list.component";

import { Patient } from 'src/app/calvin-emr-shared/models/patient.model';
import { NeurologicalAssessment } from 'src/app/calvin-emr-shared/models/assessments/neurological.model';

@Component({
  selector: 'app-neurological-info',
  templateUrl: './neurological-info.component.html',
  styleUrls: ['./neurological-info.component.scss'],
  standalone: true,
  imports: [AssessmentRowComponent, EmrListComponent],
})
export class NeurologicalInfoComponent
  extends AssessmentInfoComponent<NeurologicalAssessment>
  implements OnInit {

  patient = input.required<Patient>();

  ngOnInit(): void { }
}
